export default window._cmsContent['whd/criteria2']